window.shouldSetResult = true;
window.shouldChangeJs = false;
window.updateRequired = false;
document.addEventListener("DOMContentLoaded", async () => {
	function toggleDesktopClass() {
		if (window.innerWidth > 768) {
			document.body.classList.add("is-desktop");
		} else {
			document.body.classList.remove("is-desktop");
		}
	}

	toggleDesktopClass(); // run on load
	window.addEventListener("resize", toggleDesktopClass);
	if (!localStorage.getItem("subscriptionData")) {
		const data = {
			errorMessageColor: "black-color",
			startTimeForStep: 0,
			step: 1,
			active_steps: [0, 1],
			start: {
				isValid: true,
			},
			type: {
				id: 1,
				choosen_type: ["briefs"],
				isValid: false,
			},
			color: {
				id: 3,
				choosen_color: ["bright"],
				isValid: false,
			},
			colorFamily: {
				isValid: true,
			},
			size: {
				id: 2,
				choosen_size: "",
				isValid: false,
			},
			refresh_drawer: {
				interval: 3,
				isValid: true,
			},
			drawer: {
				id: 4,
				interval: 3,
				quantity: 4,
				quantityLimit: 2,
				price: "",
				generated: "",
				underwear: {
					pairs: "",
					skus: {},
				},
				expiration_time: 1754656440,
				choosen_underwear: [],
				isLoadedData: false,
				showWarning: false,
				unavailable_product_names: [],
				surprise_me: "no",
				isValid: true,
				correctOptions: false,
				isOneTime: false,
			},
			preferencesSaved: false,
			drawerSaved: false,
			showLoader: true,
			showDrawerError: false,
			showPreferencesError: false,
			selectedPrice: {
				value: 4,
				price: "95",
				formatted_price: "$66.50",
				renewal_price: "$95.00",
				full_price: "$124.00",
				full_price_u: 124,
				first_month_discount: "$57.50",
				first_per_pair: "$16.63",
				renewal_per_pair: "$23.75",
				isFavorite: true,
				save_percent: 30,
				save_percent_full_price: 46,
				crossed_price: "95.0",
				shopify_id: "41034608279603",
				discount: -30,
				discount_type: "percentage",
				discount_cycle_limit: 1,
			},
			serverProps: {},
			selectedColor: [],
			selectedColorFamily: [],
			errorMessage: "",
			price: "",
		};
		console.log(data);
		localStorage.setItem("subscriptionData", JSON.stringify(data));
		localStorage.setItem("local_storage_version", "2.0");
	}

	// Remove Loader after some time from wizard
	// setTimeout(() => {
	// 	document.querySelector(".loaderOptions").remove();
	// }, 400);

	// Check if any click event triggers disable checkout button
	handleDisableCheckoutButton();

	// Apply Custom app logic
	applyEasyGiftApp();
});

const applyEasyGiftApp = () => {
	const isDiscountEnabled = document.querySelector('subscription-product-wrapper').dataset.discountEnabled === "true";
	if (isDiscountEnabled) return;
	const idSaved = document.querySelector('#app_offer_id').value
	const id = idSaved ? idSaved : "";
	const timestamp = new Date().toISOString();
	const data = {
		value: [{ value: id, timestamp: timestamp }],
		timestamp: timestamp,
	};
	localStorage.setItem("EASYGIFT_TARGETING_RULES", JSON.stringify(data));
};

const handleDisableCheckoutButton = () => {
	const wrapper = document.querySelector("subscription-product-wrapper");
	const checkoutBtn = document.querySelector("#custom_checkoutbtn");
	const checkoutBtnSticky = document.querySelector("#sticky_checkout");
	wrapper.addEventListener("change", () => {
		checkoutBtn.classList.add("disabled");
		checkoutBtnSticky.classList.add("disabled");
	});
};

// subscriptionPDP.js (place this block at the very top)
class SubscriptionProductWrapper extends HTMLElement {
	constructor() {
		super();
		this.apiClient = new TuxAPIClient();
		this.cartJson = null;
	}

	async connectedCallback() {
		this.handleDiscountCode();
		await this.handleCheckAlreadyBuy();
		await this.ensureCartTokenAndHydrate();
		this.identifyHotjar();
		document.querySelector("page-header").refreshHeader();
		document.querySelector("cart-form").refresh();
	}

	handleDiscountCode() {
		const discountEnabled = this.dataset.discountEnabled === "true";
		const discountCode = this.dataset.discountCode || "";
		if (discountEnabled && discountCode) {
			fetch(`${window.Shopify.routes.root}discount/${discountCode}`);
		}
	}

	// --- 1) Clear stale local data if customer already bought ---
	async handleCheckAlreadyBuy() {
		try {
			const tempId = localStorage.getItem("tux_cart_token");
			if (!tempId) return;
			const json = await this.apiClient.getSubscriptionWithTempId(tempId);
			if (json?.already_bought) {
				localStorage.removeItem("subscriptionData");
				localStorage.removeItem("tux_cart_token");
			}
		} catch (e) {
			console.warn("[subscription] handleCheckAlreadyBuy failed", e);
		}
	}

	// --- 2) Ensure cart token + hydrate cart state ---
	async ensureCartTokenAndHydrate() {
		try {
			// reuse existing token if present
			if (localStorage.getItem("tux_cart_token")) {
				window.tux = window.tux || {};
				window.tux.cartToken = localStorage.getItem("tux_cart_token");
				if (window.tuxWizardGetOptions) window.tuxWizardGetOptions();
			}

			// always fetch cart to keep window.cartJson current
			const res = await fetch(window.Shopify.routes.root + "cart.js");
			const data = await res.json();

			if (!localStorage.getItem("tux_cart_token")) {
				window.tux = window.tux || {};
				window.tux.cartToken = data.token;
				localStorage.setItem("tux_cart_token", data.token);
			}
			this.cartJson = data;
			window.cartJson = data;
			const cartGraphql = new GetCartGraphql();
			console.log('this function is called', GetCartGraphql)
			cartGraphql.getCartGraphql()
		} catch (e) {
			console.error("[subscription] cart.js fetch failed", e);
		}
	}

	// --- 3) Hotjar identify (non-blocking) ---
	identifyHotjar() {
		setTimeout(() => {
			try {
				if (window?.hj && window?.tux?.cartToken) {
					window.hj("identify", window.tux.cartToken, {
						token: window.tux.cartToken,
					});
				}
			} catch { }
		}, 500);
	}
}

// Register the custom element once
if (!customElements.get("subscription-product-wrapper")) {
	customElements.define(
		"subscription-product-wrapper",
		SubscriptionProductWrapper
	);
}

class ConfirmSelectionButton extends HTMLElement {
	constructor() {
		super();
		this.button = this.querySelector("button");
		this.stickyBtnTitleEl = document.getElementById("split_variant_title");
	}

	async connectedCallback() {
		if (this.button) {
			this.button.addEventListener(
				"click",
				this.handleConfirmSelection.bind(this)
			);

			// ✅ Check cart on init and update button text
			await this.updateStickyButtonText();
			await this.updateStickyVariantTitle();
		}
	}

	getSelectedOptionValues() {
		return {
			type: this.getSelectedStyles(),
			size: this.getSelectedSizesValue(),
			quantity: parseInt(this.getSelectedPairs()),
			interval: 3, //currently static 3 but latter on can be dynamic
			old_options: false,
			style: [],
			color_family: [],
			color: this.getSelectedColorsValues(),
		};
	}

	getSelectedColorsValues() {
		const productColors = document.querySelector("product-color-step");
		return productColors.getSelectedColors();
	}

	getSelectedPairs() {
		const selectedPairs = document.querySelector(
			"product-variants .frequency-item.active .frequency-number"
		);
		return selectedPairs.textContent.trim();
	}

	getSelectedStyles() {
		const productStyle = document.querySelector("product-style-step");
		return productStyle.getStoresStyles();
	}

	getSelectedSizesValue() {
		const productSize = document.querySelector("product-size-step");
		return productSize.getSelectedSize();
	}

	async handleConfirmSelection(event) {
		event.preventDefault();
		this.addLoader();
		window.submitPreferences = true;

		// 1) Validate required selections
		this.clearAllFieldErrors();
		const { ok, errors } = this.validateSelections();
		if (!ok) {
			this.showValidationErrors(errors);
			this.removeLoader();
			return; // <-- stop, do not open modal
		}

		// 2) Build payload source and open modal
		const selectedData = this.getSelectedOptionValues();

		// Update options
		await this.updateTuxOptions(selectedData);

		// this.openPNRModal(selectedData);
	}

	async updateTuxOptions(selectedData) {
		const modal = document.querySelector("subscription-pnr-modal");
		await modal.fetchAndRenderOptions(selectedData);
	}

	addLoader() {
		if (this.button) {
			this.button.classList.add("is-loading");
		}
	}

	showSuccessTick() {
		if (this.button) {
			this.button.classList.remove("is-sucess");
		}
	}

	removeLoader() {
		if (this.button) {
			this.button.classList.remove("is-loading");
		}
	}

	openPNRModal(selectedData) {
		const modal = document.querySelector("subscription-pnr-modal");
		if (modal) {
			modal.OpenModel(selectedData);
		}
	}

	// ---------- Validation ----------
	validateSelections() {
		const errors = {};
		const styles = this.getSelectedStyles();
		const size = this.getSelectedSizesValue();
		const colors = this.getSelectedColorsValues();

		// style: at least one
		if (!Array.isArray(styles) || styles.length === 0) {
			errors.style = "Please choose at least one style.";
		}

		// size: must exist and be meaningful
		const hasNumeric = size && Number.isFinite(size.size);

		if (!size && !hasNumeric) {
			errors.size = "Please select your size.";
		}

		// color: at least one
		if (!Array.isArray(colors) || colors.length === 0) {
			errors.color = "Please choose at least one color.";
		}

		return { ok: Object.keys(errors).length === 0, errors };
	}

	clearAllFieldErrors() {
		document.querySelectorAll(".field-error").forEach((el) => el.remove());
		// optional aria reset
		[
			".product-style-wrapper",
			".dynamic_style_block",
			".product-size-wrapper",
			".size_block_btn",
			".product-color-wrapper",
			".color_block_btn",
		].forEach((sel) => {
			const c = document.querySelector(sel);
			if (c) c.removeAttribute("aria-invalid");
		});
	}

	showValidationErrors(errors) {
		// Style
		if (errors.style) {
			const c = this.findFirst([
				".product-style-wrapper",
				".dynamic_style_block",
				"product-style-step",
			]);
			this.injectFieldError(c, errors.style, { focusTarget: c });
		}

		// Size
		if (errors.size) {
			const c = this.findFirst([
				".product-size-wrapper",
				".size_block_btn",
				"product-size-step",
			]);
			this.injectFieldError(c, errors.size, { focusTarget: c });
		}

		// Color
		if (errors.color) {
			const c = this.findFirst([
				".product-color-wrapper",
				".color_block_btn",
				"product-color-step",
			]);
			this.injectFieldError(c, errors.color, { focusTarget: c });
		}

		// Scroll to the first error
		const firstErr = document.querySelector(".field-error");
		if (firstErr) {
			firstErr.scrollIntoView({ behavior: "smooth", block: "center" });
		}
	}

	injectFieldError(container, message, { focusTarget } = {}) {
		if (!container) return;
		const err = document.createElement("div");
		err.className = "field-error";
		err.textContent = message;

		// mark invalid region
		container.setAttribute("aria-invalid", "true");

		// place error at the end of the container (adjust as needed)
		container.appendChild(err);

		// optional focus cue
		if (focusTarget && typeof focusTarget.focus === "function") {
			try {
				focusTarget.focus();
			} catch { }
		}
	}

	findFirst(selectors) {
		for (const sel of selectors) {
			const el = document.querySelector(sel);
			if (el) return el;
		}
		return null;
	}

	async updateStickyButtonText() {
		try {
			// Get cart snapshot
			const res = await fetch(`${window.Shopify.routes.root}cart.js`);
			const cartJson = await res.json();

			// Use CustomCart to check subscription
			const cart = new CustomCart(cartJson);
			const hasSubscription = cart.checkSubscriptionInCart();

			const updateText =
				this.button.dataset.update_pairs || "Update Pairs";
			const defaultText =
				this.button.dataset.ready_toPreview || "Preview My First Box";

			const newText = hasSubscription ? updateText : defaultText;

			// ✅ Main confirm-selection button
			this.button.textContent = newText;

			// ✅ Sticky button (#sticky_ready_to_preview)
			const stickyBtn = document.getElementById(
				"sticky_ready_to_preview"
			);
			if (stickyBtn) stickyBtn.textContent = newText;

			// ✅ Extra: show checkout buttons when subscription exists
			if (hasSubscription) {
				const customCheckout =
					document.getElementById("custom_checkoutbtn");
				if (customCheckout) customCheckout.classList.remove("hidden");

				const stickyCheckout =
					document.getElementById("sticky_checkout");
				if (stickyCheckout) stickyCheckout.style.display = "block";
			}
		} catch (err) {
			console.error("Error updating button text:", err);
		}
	}

	async updateStickyVariantTitle() {
		const productVariants = document.querySelector("product-variants");
		const pairCount = productVariants.getSavedPairCount();
		this.stickyBtnTitleEl.innerText = `${pairCount} Pairs`;
	}
}

if (!customElements.get("confirm-selection")) {
	customElements.define("confirm-selection", ConfirmSelectionButton);
}

class SubscriptionPNRModel extends HTMLElement {
	constructor() {
		super();
		this.apiClient = new TuxAPIClient();
		this.optionsData = null;
		this.confirmSelectionButton = document.querySelector(
			"subscription-pnr-modal .confirm_selectionsjs"
		);
		this.surpriseInput = this.querySelector(
			'.refine-wizard-btn-group input[name="surprise_me"]'
		);
		this.closeBtn = this.querySelector(".refine-popup-close");
		// --- countdown state ---
		this.timerDisplay = this.querySelector("#countdown-timer");
		this.countdownInterval = null;
		this.timerExpired = false;

		// minutes/seconds from Liquid (theme settings)
		this.minutes = 16;
		this.seconds = 0;
		this.totalSeconds = this.minutes * 60 + this.seconds;
	}
	connectedCallback() {
		this.modelContainer = this.querySelector(".refine-popup-overlay");
		this.gridContainer = this.querySelector(".refine-popup-grid");
		// this.pairValueEl = this.querySelector(".selected_pair_value");

		this.closeBtn.addEventListener("click", this.CloseModel.bind(this));

		this.confirmSelectionButton.addEventListener(
			"click",
			this.handleFinalConfirmSelection.bind(this)
		);

		this.modelContainer.addEventListener("click", (e) => {
			// close only if user clicks the overlay, not the popup content
			if (e.target === this.modelContainer) {
				this.CloseModel();
			}
		});

		this.bindSurpriseButtons();
		this.resetTimer(); // init display
	}

	async handleFinalConfirmSelection(event) {
		document
			.querySelector("#custom_checkoutbtn")
			.classList.remove("disabled");
		if (this.isTimerExpired()) {
			event.preventDefault();
			event.stopImmediatePropagation();
			alert("Your options expired. Please refresh to get new options.");
			return;
		}
		// 🔹 Quantity validation before proceeding
		if (!this.validateQuantity()) {
			event.preventDefault();
			return; // stop execution if validation fails
		}
		try {
			event.preventDefault();
			this.addloaderToButton(event.target);
			await this.makeSelection();
			await this.addOrUpdateCart();
			this.addSucessToButton(event.target);
		} catch (e) {
			console.error("final confirm selection error", e);
		}
	}

	checkSubscriptionItemInCart(cartData) {
		return cartData?.items.find(
			(item) =>
				item.handle === "club-subscription" ||
				item.handle === "underwear-club-one-time-box"
		);
	}

	async addOrUpdateCart() {
		try {
			// 1) Get the current cart snapshot
			const cartData = this.getCartData();
			console.log('cartData', cartData)
			const subscriptionCartLineItem =
				this.checkSubscriptionItemInCart(cartData);

			// 2) Get selected variant ID (from <product-variants>)
			const productVariants = document.querySelector("product-variants");
			const variantId = productVariants.getSelectedVariantId();
			if (
				subscriptionCartLineItem &&
				String(subscriptionCartLineItem?.variant_id) !== variantId
			) {
				window.shouldChangeJs = true;
			}

			// 3) Build drawerData for Shopify cart/add.js
			const drawerData = {
				id: variantId,
				selling_plan: "1629487155", // dynamic later
				quantity: 1,
				properties: this.buildCartProperties(),
			};

			// 4) Process cart with CustomCart
			const customCart = new CustomCart(cartData);
			if (
				subscriptionCartLineItem &&
				String(subscriptionCartLineItem?.variant_id) == variantId
			) {
				//variant already exists
				if (window.shouldChangeJs) {
					await customCart.changeCartData(drawerData);
				} else console.log('Since variant is same, no need to change cart');
			} else {
				await customCart.processCartData(drawerData);
			}

			console.log("✅ Cart updated with subscription product");

			// // ✅ Redirect to checkout
			// window.location.href = `${window.Shopify.routes.root}checkout`;
			this.redirectToCheckout();
		} catch (e) {
			const refinePopupGrid = document.querySelector("refine-popup-grid");
			refinePopupGrid.showAlert("Process Failed.");
			console.error("[subscription] addOrUpdateCart failed", e);
		}
	}

	redirectToCheckout() {
		const checkoutUrl = window.graphqlCart.checkoutUrl
		window.location.assign(checkoutUrl)
	}

	buildCartProperties() {
		const props = {
			_temp_id: window.tux.cartToken,
			_ab: window.tux_ab_param || "0",
			_added_from: "PDP",
		};

		// Check hidden input _showThumnail
		const showThumbInput = document.querySelector(
			"input[name='properties[_showThumnail]']"
		);

		if (showThumbInput && showThumbInput.value === "1") {
			if (this.optionsData.surprise_me == "yes") {
				props["_subscriptionThumbnails"] = "";
				props["_showThumnail"] = "0";
			} else {
				const selectedImages = Object.entries(
					this.optionsData?.underwear?.skus || {}
				)
					.filter(([_, sku]) => sku.selected === "yes")
					.map(([_, sku]) => sku.details?.image)
					.filter(Boolean);

				if (selectedImages.length > 0) {
					props["_subscriptionThumbnails"] = selectedImages.join(",");
				}
				props["_showThumnail"] = "1";
			}
		}
		return props;
	}

	getCartData() {
		const appWrapper = document.querySelector(
			"subscription-product-wrapper"
		);
		return appWrapper.cartJson;
	}

	async makeSelection() {
		const payload = this.getSelectedPayload();
		const result = await this.apiClient.preShippingSetResults(payload);
		// --- Save to localStorage ---
		const subscriptionData =
			JSON.parse(localStorage.getItem("subscriptionData")) || {};

		// Store the result safely
		subscriptionData.drawer = result;
		subscriptionData.drawer.interval = 3;
		this.optionsData = result;

		localStorage.setItem(
			"subscriptionData",
			JSON.stringify(subscriptionData)
		);
	}

	addloaderToButton(button) {
		if (button) {
			button.classList.add("is-loading");
		}
	}

	addSucessToButton(button) {
		if (button) {
			button.classList.add("is-success");
		}

		setTimeout(() => {
			button.classList.remove("is-loading", "is-success");
		}, 400);
	}

	getSelectedUnderwear() {
		const selectedInputs = this.querySelectorAll(
			'input[name="selectedPnrProduct[]"]:checked'
		);
		const selectedUnderwearIds = Array.from(selectedInputs).map(
			(input) => input.value
		);

		// Loop through skus and update selected field
		Object.entries(this.optionsData.underwear.skus).forEach(([id, sku]) => {
			sku.selected = selectedUnderwearIds.includes(id) ? "yes" : "no";
		});
		return this.optionsData;
	}

	getSelectedPayload() {
		const selectedOptions = this.getSelectionOptions();
		const selectedUnderwear = this.getSelectedUnderwear();
		return {
			skip_preselected: true,
			subscription_attributes: {
				color: selectedOptions.color,
				exclude_color: [],
				interval: selectedOptions.interval,
				quantity: selectedOptions.quantity,
				size: selectedOptions.size,
				style: selectedOptions.style,
				type: selectedOptions.type,
			},
			surprise_me: this.getSurpriseMe(),
			token: this.getTuxToken(),
			v: null,
			underwear: {
				skus: selectedUnderwear.underwear.skus,
			},
		};
	}

	getSurpriseMe() {
		const input = this.querySelector('input[name="surprise_me"]');
		// I need to send yes or no that is input's value
		return input.value;
	}

	getSelectionOptions() {
		const button = document.querySelector("confirm-selection");
		return button.getSelectedOptionValues();
	}

	async OpenModel() {
		if (this.modelContainer) {
			// this.updatePairCount(); // 👈 update before showing
			this.modelContainer.style.display = "flex";
			this.startTimer();
			// 👉 Add class to body when popup opens
			document.body.classList.add("popup-open");
			window.scrollTo({ top: 0, behavior: "instant" });
		}
	}

	CloseModel() {
		this.resetTimer();
		if (this.modelContainer) this.modelContainer.style.display = "none";
		// 👉 Remove class from body when popup closes
		document.body.classList.remove("popup-open");
	}

	async fetchAndRenderOptions(selectedOptions) {
		try {
			const token = this.getTuxToken();
			if (!token) throw new Error("No cart token found.");
			const payload = this.getOptionsPayload(selectedOptions, token);
			const data = await this.apiClient.getTuxOptions(payload);
			this.optionsData = data;
			this.renderProductCards(data);
		} catch (e) {
			console.error("fetch and redner options error", e);
		}
	}

	async renderProductCards(data) {
		const {
			underwear: { skus },
			pairs,
		} = data;
		if (!skus) throw new Error("No sku found renderProductCard");
		const skuArray = this.convertToArray(skus);
		// Use SkuCard here
		const cardsHtml = skuArray
			.map((sku) => new SkuCard(sku).render())
			.join("");
		this.gridContainer.innerHTML = cardsHtml;

		// ✅ Find already selected IDs
		const selectedIds = Object.entries(skus)
			.filter(([_, sku]) => sku.selected === "yes")
			.map(([id]) => id);

		// ✅ Render showcase using shared method
		this.renderShowcase(pairs, selectedIds);
		this.renderGiftPlaceholders(pairs);
		// ✅ Apply surprise state on load
		this.updateSurpriseState(data.surprise_me === "yes");
		await this.showSuccess();
		setTimeout(() => {
			this.OpenModel();
			// const refinePopupGrid = document.querySelector("refine-popup-grid");
			// refinePopupGrid.init();
		}, 400);
	}

	renderGiftPlaceholders(quantity = 0) {
		const giftShowcase = this.querySelector(".selected_pair_gift_inner");
		if (!giftShowcase) return;

		giftShowcase.innerHTML = ""; // clear existing

		for (let i = 1; i <= quantity; i++) {
			const slot = document.createElement("div");
			slot.classList.add("s_p_g_item", "surprise");
			slot.innerHTML = `<svg width="49" height="48" viewBox="0 0 49 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M37.7998 16.3498H30.1198C31.4216 15.6164 32.0398 14.6334 32.1627 13.6618C32.2483 13.0315 32.0958 12.3918 31.7351 11.8678C31.3744 11.3438 30.8314 10.9731 30.212 10.8279C28.5915 10.4439 26.3259 11.4922 24.5249 15.4359C22.7278 11.5076 20.4622 10.4439 18.8417 10.8279C18.2224 10.9731 17.6793 11.3438 17.3186 11.8678C16.9579 12.3918 16.8055 13.0315 16.891 13.6618C17.0024 14.618 17.6321 15.601 18.9339 16.3498H11.2539V23.1005H12.8091V37.4353H36.2715V23.1005H37.8305L37.7998 16.3498ZM29.54 11.9185C29.6691 11.9184 29.7979 11.9325 29.924 11.9607C30.2675 12.0432 30.5682 12.2503 30.7676 12.542C30.967 12.8336 31.0509 13.1889 31.003 13.539C30.8571 14.7524 29.2827 16.154 25.3659 16.3306C26.7521 13.0628 28.3803 11.9185 29.54 11.9185ZM18.02 13.539C17.9711 13.1893 18.0541 12.834 18.2529 12.5423C18.4516 12.2505 18.7519 12.0432 19.0952 11.9607C19.2213 11.9329 19.35 11.9187 19.4792 11.9185C20.6312 11.9185 22.267 13.0705 23.6494 16.3306C19.7403 16.154 18.1621 14.7524 18.02 13.539ZM12.3752 21.9486V17.5018H23.9336V21.9486H12.3752ZM13.9304 23.1005H23.9336V36.2833H13.9304V23.1005ZM35.0888 36.2833H25.1048V23.1005H35.0888V36.2833ZM36.6478 21.9486H25.0856V17.5018H36.6478V21.9486Z" fill="#3C20E7"></path></svg>`;
			giftShowcase.appendChild(slot);
		}
	}

	async showSuccess() {
		const button = document.querySelector("confirm-selection button");
		if (button) {
			button.classList.add("is-success");
			setTimeout(() => {
				button.classList.remove("is-success", "is-loading");
			}, 800);
		} else console.log("somethink wrong with button");
	}

	convertToArray(object) {
		return Object.entries(object)
			.map(([id, data]) => ({
				id,
				...data.details,
				selected: data.selected,
				preselected: data.preselected,
				strict: data.strict,
			}))
			.sort((a, b) => (b.selected === "yes") - (a.selected === "yes"));
	}

	getOptionsPayload(selectedOptions, token) {
		return {
			subscription_attributes: selectedOptions,
			v: null,
			token,
		};
	}

	getTuxToken() {
		return localStorage.getItem("tux_cart_token");
	}

	bindSurpriseButtons() {
		const buttons = this.querySelectorAll(".refine-wizard-btn");
		buttons.forEach((btn) =>
			btn.addEventListener("click", (evt) => {
				evt.preventDefault();
				const isSurprise = btn.classList.contains("surprise_me");
				this.updateSurpriseState(isSurprise);
			})
		);
	}

	updateSurpriseState(isSurprise) {
		// hidden input
		if (this.surpriseInput) {
			this.surpriseInput.value = isSurprise ? "yes" : "no";
		}

		// button highlight
		const buttons = this.querySelectorAll(".refine-wizard-btn");
		buttons.forEach((b) => b.classList.remove("selected"));
		const target = this.querySelector(
			isSurprise
				? ".refine-wizard-btn.surprise_me"
				: ".refine-wizard-btn.let_mechoose"
		);
		if (target) target.classList.add("selected");

		// UI toggle
		this.toggleSurpriseUI(isSurprise);
	}

	toggleSurpriseUI(isSurprise) {
		const surpriseText = this.querySelector("p.surprise_metext");
		const countdown = this.querySelector(".countdown-time");
		const selectedPairsGift = this.querySelector(".selected_pairs_gift");
		const selectedPairsShowcase = this.querySelector(
			".selected_pairs_showcase"
		);

		if (isSurprise) {
			this.gridContainer.style.display = "none";
			if (countdown) countdown.style.display = "none";
			if (surpriseText) surpriseText.style.display = "block";
			if (selectedPairsGift) selectedPairsGift.style.display = "block";
			if (selectedPairsShowcase)
				selectedPairsShowcase.style.display = "none";
		} else {
			this.gridContainer.style.display = "flex";
			if (countdown) countdown.style.display = "flex";
			if (surpriseText) surpriseText.style.display = "none";
			if (selectedPairsGift) selectedPairsGift.style.display = "none";
			if (selectedPairsShowcase)
				selectedPairsShowcase.style.display = "block";
		}
	}

	/* ---------------- Timer Methods ---------------- */
	startTimer() {
		clearInterval(this.countdownInterval);
		this.timerExpired = false;

		let timer = this.totalSeconds;
		this.countdownInterval = setInterval(() => {
			const m = String(parseInt(timer / 60, 10)).padStart(2, "0");
			const s = String(parseInt(timer % 60, 10)).padStart(2, "0");
			if (this.timerDisplay) {
				this.timerDisplay.textContent = `${m}:${s}`;
			}

			if (--timer < 0) {
				clearInterval(this.countdownInterval);
				this.timerExpired = true;
				if (this.timerDisplay) this.timerDisplay.textContent = "00:00";
			}
		}, 1000);
	}

	resetTimer() {
		clearInterval(this.countdownInterval);
		this.timerExpired = false;
		const m = String(this.minutes).padStart(2, "0");
		const s = String(this.seconds).padStart(2, "0");
		if (this.timerDisplay) this.timerDisplay.textContent = `${m}:${s}`;
	}

	isTimerExpired() {
		return this.timerExpired;
	}

	/* ---------------- Validation Helpers ---------------- */
	validateQuantity() {
		const surpriseMe = this.getSurpriseMe() === "yes";

		// get required quantity (from subscription attributes or optionsData)
		const quantity =
			this.getSelectionOptions()?.quantity ||
			this.optionsData?.underwear?.pairs ||
			0;

		// count selected SKUs
		const selectedCount = this.querySelectorAll(
			'input[name="selectedPnrProduct[]"]:checked'
		).length;

		if (!surpriseMe && selectedCount !== quantity) {
			this.showQuantityError(quantity);
			return false;
		}
		return true;
	}

	showQuantityError(quantity) {
		let erroText = `
			Please select exactly ${quantity} items to proceed.`;
		const refinePopupGrid = document.querySelector("refine-popup-grid");
		refinePopupGrid.showAlert(erroText);
	}

	// updatePairCount() {
	// 	try {
	// 		const button = document.querySelector("confirm-selection");
	// 		const quantity = button.getSelectedPairs() || 0;

	// 		if (this.pairValueEl) {
	// 			this.pairValueEl.textContent = quantity;
	// 		}
	// 	} catch (err) {
	// 		console.warn("Failed to update pair count:", err);
	// 		if (this.pairValueEl) this.pairValueEl.textContent = "";
	// 	}
	// }

	renderShowcase(quantity = 0, selectedIds = []) {
		const showcase = this.querySelector(".selected_pair_wizard");
		if (!showcase) return;

		showcase.innerHTML = ""; // clear existing

		for (let i = 0; i < quantity; i++) {
			const wrapper = document.createElement("div");
			wrapper.classList.add("s_p_w_item");

			const skuId = selectedIds[i];
			if (skuId) {
				const sku = this.optionsData?.underwear?.skus[skuId];
				const imgUrl = sku?.details?.image;

				if (imgUrl) {
					const img = document.createElement("img");
					img.classList.add("round-border");
					img.src = imgUrl;
					wrapper.appendChild(img);
					wrapper.classList.add("selected");
				}
			} else {
				wrapper.innerHTML = `<span>Pair</span><span>${i + 1}</span>`;
				wrapper.classList.add("missing");
			}

			showcase.appendChild(wrapper);
		}
	}
}

if (!customElements.get("subscription-pnr-modal")) {
	customElements.define("subscription-pnr-modal", SubscriptionPNRModel);
}

class RefinePopupGrid extends HTMLElement {
	constructor() {
		super();
		this.handleCardClick = this.handleCardClick.bind(this);
	}
	connectedCallback() {
		this.addEventListener("click", this.handleCardClick.bind(this));
	}
	// async init() {
	// 	this.addEventListener("click", this.handleCardClick.bind(this));
	// }

	handleCardClick(e) {
		const card = this.findCard(e);
		if (!card) return;

		const selectedValues = this.getSelectedValues();
		const max = this.getMaxSelection();

		if (
			!card.classList.contains("selected") &&
			selectedValues.length >= max
		) {
			this.showSelectionLimitAlert(max);
			return; // stop further toggling
		}
		this.toggleCard(card);
		this.syncCheckbox(card);
		// ✅ Update showcase with new selections
		this.updateShowcase();
	}

	showSelectionLimitAlert(max) {
		this.showAlert(`Please deselect an item before making a new choice`);
	}

	showAlert(text) {
		const errorContainer = document.querySelector(
			"subscription-pnr-modal .cst_warning-wrap"
		);
		const errorTextSpan = document.querySelector(
			"subscription-pnr-modal .cst_warning-wrap .warningText"
		);
		if (errorContainer && errorTextSpan) {
			errorTextSpan.textContent = text;
			errorContainer.classList.add("cst_warning-show");
			setTimeout(() => {
				errorContainer.classList.remove("cst_warning-show");
			}, 1500);
		}
	}

	getMaxSelection() {
		return parseInt(
			document.querySelector("subscription-pnr-modal")?.optionsData
				?.underwear?.pairs || 6
		);
	}

	findCard(e) {
		const card = e.target.closest(".refine-popup-card");
		return card && this.contains(card) ? card : null;
	}

	toggleCard(card) {
		card.classList.toggle("selected");
	}

	syncCheckbox(card) {
		const checkbox = card.querySelector('input[type="checkbox"]');
		if (!checkbox) return;
		checkbox.checked = card.classList.contains("selected");
	}

	getSelectedValues() {
		return [
			...this.querySelectorAll(
				'input[name="selectedPnrProduct[]"]:checked'
			),
		].map((input) => input.value);
	}

	updateShowcase() {
		// find modal + optionsData
		const modal = document.querySelector("subscription-pnr-modal");
		if (!modal || !modal.optionsData) return;

		const quantity =
			modal.optionsData?.underwear?.pairs ||
			modal.optionsData?.pairs ||
			0;

		// selected sku ids
		const selectedIds = this.getSelectedValues();
		modal.renderShowcase(quantity, selectedIds);
	}
}

if (!customElements.get("refine-popup-grid")) {
	customElements.define("refine-popup-grid", RefinePopupGrid);
}

class ProductStyle extends HTMLElement {
	constructor() {
		super();
		this._initialized = false;
		this.wizardSettings = null;
		this.apiClient = new TuxAPIClient();
		this.storedStyles = this.getStoresStyles();
		this.svgIcons = this.apiClient.getStylesIcons();
		this.container = document.querySelector(".dynamic_style_block");
		// this.addEventListener("change", this.handleStyleChange.bind(this));
	}

	async connectedCallback() {
		if (this._initialized) return; // prevent double call
		this._initialized = true;

		await this.loadWizardSettings();
		this.renderOptions();
	}

	renderOptions() {
		if (this.wizardSettings) {
			const html = this.getOptionsHtml(
				this.wizardSettings.type_options,
				2
			);
			this.container.innerHTML = html;
			this.container.addEventListener(
				"change",
				this.handleStyleChange.bind(this)
			);
		}
	}

	getSelectedStyles() {
		const checkedInputs = this.container.querySelectorAll(
			'input[name="style_options"]:checked'
		);
		const selectedStyles = Array.from(checkedInputs).map(
			(input) => input.value
		);
		return selectedStyles;
	}

	handleStyleChange(event) {
		const selectedStyles = this.getSelectedStyles();
		var styleWrapper = document.querySelector(".product-style-wrapper");
		this.toggleErrorVisibility(
			styleWrapper,
			selectedStyles.length === 0,
			"Please choose at least one style."
		);
		this.setStoredStyles(selectedStyles);
	}

	toggleErrorVisibility(container, show, message = "") {
		if (!container) return;

		// Try to find existing error field
		let errorField = container.querySelector(".field-error");

		// ✅ Show error
		if (show) {
			// If not exists, create and append
			if (!errorField && window.submitPreferences) {
				errorField = document.createElement("div");
				errorField.className = "field-error";
				errorField.textContent = message;
				container.appendChild(errorField);
			}

			if (errorField) {
				errorField.style.display = "block";
				container.setAttribute("aria-invalid", "true");
			}
		}

		// ❌ Hide error
		else {
			if (errorField) {
				errorField.style.display = "none";
			}
			container.removeAttribute("aria-invalid");
		}
	}

	getOptionsHtml(options, ignoreIndex) {
		return options
			.map((option, index) => {
				if (index === ignoreIndex) return "";
				return this.getOptionHtml(option, index);
			})
			.join("");
	}

	getOptionHtml(option, index) {
		const { value, title } = option;
		const inputId = `style_option_${index}`;
		const svg = this.svgIcons[value];
		const isChecked = this.storedStyles.includes(value) ? "checked" : "";
		return `
            <div class="style-item option_blocks-item">
            <input type="checkbox" id="${inputId}" name="style_options" value="${value}" class="visually-hidden" ${isChecked}>
            <label for="${inputId}" aria-label="Select style: ${title}">
                <div class="option_blocks-item-media">
                    <div class="badge-circle">
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="10" viewBox="0 0 15 10" aria-hidden="true">
                            <path d="M5.80193 7.6341L13.0988 0.336426L14.2221 1.4589L5.80193 9.87905L0.75 4.82712L1.87248 3.70464L5.80193 7.6341Z" fill="white"/>
                        </svg>
                    </div>
                    ${svg}
                </div>
                <div class="style-label option_blocks-item-name">${title}</div>
            </label>
            </div>
        `;
	}

	getStoresStyles() {
		const subscriptionData = this.getSubscriptionData();
		return subscriptionData?.type?.choosen_type || [];
	}

	getSubscriptionData() {
		const subscriptionData = localStorage.getItem("subscriptionData");
		const parsed = subscriptionData ? JSON.parse(subscriptionData) : {};
		return parsed;
	}

	setSubscriptionData(data) {
		localStorage.setItem("subscriptionData", JSON.stringify(data));
		localStorage.setItem("local_storage_version", "2.0");
	}

	setStoredStyles(styles) {
		let subscriptionData = this.getSubscriptionData();
		subscriptionData.type = subscriptionData.type || {};
		subscriptionData.type.choosen_type = styles;
		this.setSubscriptionData(subscriptionData);
		this.storedStyles = styles;
	}

	async loadWizardSettings() {
		try {
			this.wizardSettings = await this.apiClient.getWizardSettings();
			if (!this.wizardSettings) {
				this.showReloadPrompt();
				return;
			}
			setTimeout(() => {
				document.querySelector(".loaderOptions").remove();
			}, 200);

			// Notify others that wizardSettings is ready
			this.dispatchEvent(
				new CustomEvent("wizardSettingsLoaded", {
					detail: { wizardSettings: this.wizardSettings },
					bubbles: true,
				})
			);
		} catch (error) {
			console.error("Failed to load wizard settings:", error);
		}
	}

	showReloadPrompt() {
		const reload = window.confirm(
			"Network issue detected.\n\nPlease reload the page to continue."
		);

		if (reload) {
			window.location.reload();
		}
	}
}
if (!customElements.get("product-style-step")) {
	customElements.define("product-style-step", ProductStyle);
}

class ProductSize extends HTMLElement {
	constructor() {
		super();
		this.apiClient = new TuxAPIClient();
		this.productStyle = document.querySelector("product-style-step");
		this.wizardSettings = this.productStyle?.wizardSettings;
		this.container = document.querySelector(".size_block_btn");
		this.isLetterSize = false;
		this.selectedLetter = null;
		this.selectedNumeric = null;
		this.groups = [];
	}

	async connectedCallback() {
		if (this.productStyle?.wizardSettings) {
			// Wizard settings already loaded: proceed
			this.wizardSettings = this.productStyle.wizardSettings;
			this.init();
		} else {
			// Wait for event
			this.productStyle?.addEventListener(
				"wizardSettingsLoaded",
				(event) => {
					this.wizardSettings = event.detail.wizardSettings;
					this.init();
				}
			);
		}
	}

	init() {
		this.initializeState();
		this.renderSizeSelector();
		this.setupEventListeners();
	}

	initializeState() {
		// Parse size groups from wizard settings
		this.groups = this.wizardSettings.sizes_options_by_name
			.filter(
				(g) => g?.name && Array.isArray(g?.sizes) && g.sizes.length > 0
			)
			.map((g) => ({
				name: String(g.name).toUpperCase(),
				sizes: g.sizes
					.map((s) => Number(s.value))
					.filter((v) => !Number.isNaN(v)),
			}));

		// Create mapping from numeric sizes to letter groups
		this.numericToGroup = new Map();
		this.groups.forEach((g) =>
			g.sizes.forEach((v) => this.numericToGroup.set(v, g.name))
		);

		// Load persisted selection
		const subscriptionData = this.productStyle.getSubscriptionData();
		if (subscriptionData?.size) {
			const size = subscriptionData.size;

			if (size.is_letter_size === true) {
				this.isLetterSize = true;
				this.selectedLetter = String(size.choosen_size).toUpperCase();
				this.selectedNumeric =
					this.getSecondValueForGroup(this.selectedLetter) ||
					this.getFirstValueForGroup(this.selectedLetter);
			} else {
				this.isLetterSize = false;
				const choosenSize = size.choosen_size;

				// ✅ Skip if choosen_size is empty or null
				if (!choosenSize) {
					return;
				}

				const num = Number(choosenSize);
				if (!Number.isNaN(num)) {
					this.selectedNumeric = num;
					this.selectedLetter =
						this.numericToGroup.get(num) || this.groups[0]?.name;
				}
			}
		}

		// Set defaults if no selection found
		// if (!this.selectedLetter && this.groups.length > 0) {
		// 	this.selectedLetter = this.groups[0].name;
		// 	this.selectedNumeric = this.groups[0].sizes[0];
		// }
	}

	getFirstValueForGroup(letter) {
		const group = this.groups.find(
			(g) => g.name === String(letter).toUpperCase()
		);
		return group?.sizes?.[0] ?? null;
	}

	getSecondValueForGroup(letter) {
		const group = this.groups.find(
			(g) => g.name === String(letter).toUpperCase()
		);
		return group?.sizes?.length >= 2
			? group.sizes[1]
			: group?.sizes?.[0] ?? null;
	}

	getGroupByNumeric(n) {
		return this.numericToGroup.get(Number(n)) || null;
	}

	getSelectedSize() {
		return this.selectedNumeric;
	}

	isLetter() {
		return this.isLetterSize;
	}

	persistSelection() {
		const subscriptionData = this.productStyle.getSubscriptionData();

		subscriptionData.size = {
			...subscriptionData.size,
			id: subscriptionData.size?.id || 2,
			choosen_size: this.isLetterSize
				? this.selectedLetter
				: this.selectedNumeric,
			isValid: true,
			is_letter_size: this.isLetterSize,
			is_numeric_size: !this.isLetterSize,
			letter_group: this.selectedLetter,
			numeric_value: this.selectedNumeric,
		};

		this.productStyle.setSubscriptionData(subscriptionData);
	}

	renderSizeSelector() {
		if (!this.container) return;

		this.container.innerHTML = `
            <div class="render_new_sizebox">
                <span class="no_waistsize ${!this.isLetterSize ? "size_active" : ""
			}" 
                      style="display: ${!this.isLetterSize ? "inline-block" : "none"
			};">
                    I don't know my waist size
                </span>
                <span class="show_waistsizeselectbox ${this.isLetterSize ? "size_active" : ""
			}" 
                      style="display: ${this.isLetterSize ? "inline-block" : "none"
			};">
                    I know my waist size
                </span>
            </div>
            <div class="custom-select-wrapper">
                <div class="custom-select" name="xyz" aria-label="Select size" id="selected-value" role="combobox" aria-expanded="false" aria-haspopup="listbox">
                    <span>${this.getDisplayText()}</span>
                    <div class="dropDownIcon" aria-hidden="true">
                        <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" class="css-8mmkcg">
                            <path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path>
                        </svg>
                    </div>
                </div>
                <div class="custom-options" id="options-list" role="listbox" style="display: none;">
                    ${this.getOptionsHtml()}
                </div>
            </div>
        `;
	}

	getDisplayText() {
		if (this.isLetterSize) return this.selectedLetter || "Select size";
		return this.selectedNumeric != null
			? `${this.selectedNumeric} inches`
			: "Select size";
	}

	getOptionsHtml() {
		const options = this.isLetterSize
			? this.groups.map((g) => ({ value: g.name }))
			: this.groups.flatMap((g) => g.sizes.map((v) => ({ value: v })));

		return options
			.map(
				(o) => `
            <div value="${o.value}" role="option" tabindex="0">
                ${this.isLetterSize ? o.value : o.value + " inches"}
            </div>
        `
			)
			.join("");
	}

	setupEventListeners() {
		const noWaistSizeBtn = this.container.querySelector(".no_waistsize");
		const showWaistSizeBtn = this.container.querySelector(
			".show_waistsizeselectbox"
		);
		const customSelect = this.container.querySelector(".custom-select");
		const optionsList = this.container.querySelector(".custom-options");

		noWaistSizeBtn?.addEventListener("click", () => this.switchToLetter());
		showWaistSizeBtn?.addEventListener("click", () =>
			this.switchToNumeric()
		);

		customSelect?.addEventListener("click", () => {
			const isExpanded =
				customSelect.getAttribute("aria-expanded") === "true";
			customSelect.setAttribute("aria-expanded", !isExpanded);
			optionsList.style.display = isExpanded ? "none" : "block";
		});

		optionsList?.addEventListener("click", (e) => {
			const option = e.target.closest('[role="option"]');
			if (option) {
				this.onOptionSelect(option.getAttribute("value"));
				optionsList.style.display = "none";
				customSelect.setAttribute("aria-expanded", "false");
			}
		});

		// Close dropdown when clicking outside
		document.addEventListener("click", (e) => {
			if (!this.container.contains(e.target)) {
				optionsList.style.display = "none";
				customSelect.setAttribute("aria-expanded", "false");
			}
		});
	}

	switchToLetter() {
		if (!this.selectedLetter && this.selectedNumeric != null) {
			this.selectedLetter =
				this.getGroupByNumeric(this.selectedNumeric) ||
				this.groups[0]?.name;
		}

		this.isLetterSize = true;
		this.selectedNumeric = this.selectedLetter
			? this.getSecondValueForGroup(this.selectedLetter) ||
			this.getFirstValueForGroup(this.selectedLetter)
			: this.selectedNumeric;

		this.updateUI();
		this.persistSelection();
	}

	switchToNumeric() {
		if (this.selectedLetter) {
			this.selectedNumeric =
				this.getSecondValueForGroup(this.selectedLetter) ||
				this.getFirstValueForGroup(this.selectedLetter) ||
				this.selectedNumeric;
		}

		this.isLetterSize = false;
		this.updateUI();
		this.persistSelection();
	}

	onOptionSelect(rawValue) {
		if (this.isLetterSize) {
			this.selectedLetter = String(rawValue).toUpperCase();
			this.selectedNumeric =
				this.getSecondValueForGroup(this.selectedLetter) ||
				this.getFirstValueForGroup(this.selectedLetter);
		} else {
			const num = Number(rawValue);
			if (!Number.isNaN(num)) {
				this.selectedNumeric = num;
				this.selectedLetter =
					this.getGroupByNumeric(num) || this.selectedLetter;
			}
		}

		var sizeWrapper = document.querySelector(".product-size-wrapper");

		this.productStyle.toggleErrorVisibility(
			sizeWrapper,
			!this.selectedNumeric,
			"Please select your size."
		);
		this.updateSelectedDisplay();
		this.persistSelection();
	}

	updateUI() {
		const noWaistSizeBtn = this.container.querySelector(".no_waistsize");
		const showWaistSizeBtn = this.container.querySelector(
			".show_waistsizeselectbox"
		);

		if (this.isLetterSize) {
			noWaistSizeBtn.style.display = "none";
			noWaistSizeBtn.classList.remove("size_active");
			showWaistSizeBtn.style.display = "inline-block";
			showWaistSizeBtn.classList.add("size_active");
		} else {
			showWaistSizeBtn.style.display = "none";
			showWaistSizeBtn.classList.remove("size_active");
			noWaistSizeBtn.style.display = "inline-block";
			noWaistSizeBtn.classList.add("size_active");
		}

		this.refreshOptions();
		this.updateSelectedDisplay();
	}

	refreshOptions() {
		const optionsList = this.container.querySelector("#options-list");
		if (optionsList) {
			optionsList.innerHTML = this.getOptionsHtml();
		}
	}

	updateSelectedDisplay() {
		const selectedSpan = this.container.querySelector(
			"#selected-value span"
		);
		if (selectedSpan) {
			selectedSpan.textContent = this.getDisplayText();
		}
	}
}

// Register the custom element
if (!customElements.get("product-size-step")) {
	customElements.define("product-size-step", ProductSize);
}

// ----- Color Step (Web Component) -----

class ProductColor extends HTMLElement {
	constructor() {
		super();
		this.productStyle = document.querySelector("product-style-step");
		this.wizardSettings = this.productStyle?.wizardSettings;
		this.container = document.querySelector(".color_block_btn");
		this.selected = []; // normalized values
		this._debounceTimer = null;

		// binders
		this.handleChange = this.handleChange.bind(this);
		this.debouncedUpdate = this.debounce(
			this.updateSubscriptionData.bind(this),
			300
		);
	}

	async connectedCallback() {
		// If wizard settings already available, init immediately
		if (this.productStyle?.wizardSettings) {
			this.wizardSettings = this.productStyle.wizardSettings;
			this.init();
		} else {
			// Wait for style component to broadcast settings
			this.productStyle?.addEventListener(
				"wizardSettingsLoaded",
				(evt) => {
					this.wizardSettings = evt.detail.wizardSettings;
					this.init();
				}
			);
		}
	}

	// ---------- init / render ----------

	init() {
		if (!this.container) return;
		const colors = Array.isArray(this.wizardSettings?.color_options)
			? this.wizardSettings.color_options
			: [];

		// load from storage first
		this.selected = this.getStoredColors();

		// draw once
		this.render(colors);
		this.attachListeners();
		// ensure storage is up to date with initial state
		this.debouncedUpdate();
	}

	render(colorOptions) {
		if (!this.container) return;
		if (!Array.isArray(colorOptions) || colorOptions.length === 0) {
			this.container.innerHTML = "";
			return;
		}

		const frag = document.createDocumentFragment();

		colorOptions.forEach(({ label, value, image_url }, index) => {
			const norm = this.normalize(value);
			const checked = this.selected.includes(norm);

			const inputId = `color_option_${index}`;
			const div = document.createElement("div");
			div.className = "color-item option_blocks-item";
			div.setAttribute("options-title", label || "");

			div.innerHTML = `
        <input type="checkbox"
               id="${inputId}"
               name="color_options"
               value="${value}"
               class="visually-hidden"
               ${checked ? "checked" : ""}>

        <label for="${inputId}" aria-label="Select color: ${label}">
          <div class="option_blocks-item-media ${label !== "White" ? "BgImg" : ""
				}"
               data-colorvalue="${label}">
            <div class="badge-circle">
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="10" viewBox="0 0 15 10" aria-hidden="true">
                <path d="M5.80193 7.6341L13.0988 0.336426L14.2221 1.4589L5.80193 9.87905L0.75 4.82712L1.87248 3.70464L5.80193 7.6341Z" fill="white"></path>
              </svg>
            </div>
            <div class="option_blocks-item-media-in"
                 style="background-image: ${image_url ? `url(${image_url})` : "none"
				};"></div>
          </div>
          <div class="color-label option_blocks-item-name">${label}</div>
        </label>
      `;

			frag.appendChild(div);
		});

		// paint
		this.container.innerHTML = "";
		this.container.appendChild(frag);
	}

	attachListeners() {
		// listen to changes on the container (event delegation)
		this.container.addEventListener("change", this.handleChange);
	}

	// ---------- handlers ----------
	handleChange(e) {
		const target = e.target;
		if (!(target instanceof HTMLInputElement)) return;
		if (target.name !== "color_options") return;

		// prevent checkout until re-confirm
		this.blockCheckoutUntilConfirm();

		// hide any visible generic error
		const err = document.querySelector(".error-msg");
		if (err) {
			err.style.display = "none";
			err.classList.add("hidden");
		}

		// recompute selection from currently checked inputs
		const checked = this.container.querySelectorAll(
			'input[name="color_options"]:checked'
		);
		this.selected = Array.from(checked).map((input) =>
			this.normalize(input.value)
		);
		var colorWrapper = document.querySelector(".product-color-wrapper");
		this.productStyle.toggleErrorVisibility(
			colorWrapper,
			this.selected.length === 0,
			"Please choose at least one color."
		);

		// write to storage (debounced)
		this.debouncedUpdate();
	}

	getSelectedColors() {
		const checkedInputs = this.container.querySelectorAll(
			'input[name="color_options"]:checked'
		);
		const selectedColors = Array.from(checkedInputs).map(
			(input) => input.value
		);
		return selectedColors;
	}

	// ---------- storage ----------
	normalize(str) {
		return String(str || "")
			.toLowerCase()
			.replace(/\bcolors?\b/g, "")
			.trim();
	}

	getStoredColors() {
		try {
			const sub = this.productStyle.getSubscriptionData();
			const arr = sub?.color?.choosen_color || [];
			return Array.isArray(arr) ? arr.map((v) => this.normalize(v)) : [];
		} catch (err) {
			console.warn("Invalid subscriptionData for colors:", err);
			return [];
		}
	}

	updateSubscriptionData() {
		const sub = this.productStyle.getSubscriptionData();

		sub.color = {
			...sub.color,
			id: sub.color?.id || 3,
			choosen_color: this.selected.slice(), // normalized list
			isValid: true,
		};

		this.productStyle.setSubscriptionData(sub);
	}

	// ---------- utils ----------
	debounce(fn, delay = 300) {
		return (...args) => {
			clearTimeout(this._debounceTimer);
			this._debounceTimer = setTimeout(() => fn(...args), delay);
		};
	}

	blockCheckoutUntilConfirm() {
		const buttons = document.querySelectorAll(".redirect_to_checkout");
		buttons.forEach((btn) => btn.classList.add("no_redirect_to_checkout"));
	}
}

// Register the custom element
if (!customElements.get("product-color-step")) {
	customElements.define("product-color-step", ProductColor);
}

class ProductVariants extends HTMLElement {
	constructor() {
		super();
		this.items = [];
		this._listeners = [];
		this.productStyle = document.querySelector("product-style-step");
	}

	connectedCallback() {
		this.init();
	}

	init() {
		// find cards only inside this custom element
		this.items = Array.from(this.querySelectorAll(".frequency-item"));
		if (this.items.length === 0) return;

		// normalize initial state
		this.items.forEach((el) => {
			el.classList.remove("active");
			const cb = el.querySelector('input[type="checkbox"]');
			if (cb) cb.checked = false;
		});

		// bind listeners
		this.items.forEach((el) => {
			const handler = (evt) => this.onItemClick(el, evt);
			el.addEventListener("click", handler);
			this._listeners.push([el, handler]);
		});

		// ---------- DEFAULT SELECTION ----------
		// 1) Use saved pair count from subscriptionData if present & matches a card
		const saved = this.getSavedPairCount();
		let target =
			saved != null
				? this.items.find((it) => this.getPairs(it) === saved)
				: null;

		// 2) Else respect any pre-checked/active in markup
		if (!target) {
			target =
				this.items.find(
					(el) =>
						el.classList.contains("active") ||
						el.querySelector('input[type="checkbox"]')?.checked
				) ||
				// 3) Else default to 2nd, else 1st
				this.items[Math.min(1, this.items.length - 1)] ||
				this.items[0];
		}

		// Apply that selection and persist (keeps storage consistent with UI)
		this.applySelection(target, /*updateStorage*/ true);
	}

	/* ---------- events ---------- */

	onItemClick(item, _evt) {
		// optional: hide global refine overlay if present
		const overlay = document.querySelector(".refine-popup-overlay");
		if (overlay) overlay.style.display = "none";

		const pairCount = this.getSavedPairCount();
		document.getElementById(
			"split_variant_title"
		).innerText = `${pairCount} Pairs`;

		this.applySelection(item, /*updateStorage*/ true);
	}

	/* ---------- selection core ---------- */

	applySelection(item, updateStorage) {
		// deselect others (inside this component only)
		this.items.forEach((el) => {
			el.classList.remove("active");
			const cb = el.querySelector('input[type="checkbox"]');
			if (cb) cb.checked = false;
		});

		// select current
		item.classList.add("active");
		const cb = item.querySelector('input[type="checkbox"]');
		if (cb) cb.checked = true;

		// compute + display per-item price inside this component
		const pairs = this.getPairs(item);
		const bundlePrice = this.getBundlePrice(item); // from data-price
		this.updatePerItemPrice(bundlePrice, pairs);

		// persist to localStorage
		if (updateStorage) {
			const priceValue = this.getPriceValue(item); // from data-2pairs (string, $ stripped)
			this.updateSubscriptionData({ value: pairs, price: priceValue });
		}
	}

	/* ---------- DOM → values (scoped to item) ---------- */

	getPairs(item) {
		const txt =
			item.querySelector(".frequency-number")?.textContent?.trim() || "";
		const n = parseInt(txt, 10);
		return Number.isFinite(n) && n > 0 ? n : 1;
	}

	// <div class="frequency-prices" data-2pairs="$68">
	getPriceValue(item) {
		const raw =
			item
				.querySelector(".frequency-prices")
				?.getAttribute("data-2pairs") || "";
		return raw.replace(/^\$/, "");
	}

	// <div class="frequency-prices" data-price="95">
	getBundlePrice(item) {
		const raw =
			item
				.querySelector(".frequency-prices")
				?.getAttribute("data-price") || "";
		const f = parseFloat(raw);
		return Number.isFinite(f) ? f : NaN;
	}

	updatePerItemPrice(bundlePrice, pairs) {
		if (
			!Number.isFinite(bundlePrice) ||
			!Number.isFinite(pairs) ||
			pairs === 0
		)
			return;
		const perItem = Math.round(bundlePrice / pairs);
		// look for .pair-calculation inside this component first
		const el =
			this.querySelector(".pair-calculation") ||
			// fallback to document if your text lives outside
			document.querySelector(".pair-calculation");
		if (el) el.innerHTML = `only $${perItem} per underwear!`;
	}

	// Read saved pair count from localStorage (check several keys; first valid wins)
	getSavedPairCount() {
		try {
			const data =
				JSON.parse(localStorage.getItem("subscriptionData")) || {};
			const candidates = [
				data.drawer?.quantity, // preferred
				data.quantity, // legacy
				data.selectedPrice?.value, // sometimes stored here
			];
			for (const c of candidates) {
				const n = parseInt(c, 10);
				if (Number.isFinite(n) && n > 0) return n;
			}
		} catch (_) { }
		return null;
	}

	updateSubscriptionData({ value, price }) {
		const data = this.productStyle.getSubscriptionData();

		data.selectedPrice = {
			...(data.selectedPrice || {}),
			value, // number of pairs
			price, // string (no leading $)
		};

		// keep quantity in both locations for compatibility with existing code
		data.drawer = data.drawer || {};
		data.drawer.quantity = value;
		data.drawer.interval = 3;
		data.quantity = value;

		this.productStyle.setSubscriptionData(data);
	}

	getSelectedVariantId() {
		const active = this.querySelector(
			".frequency-item.active input[type='checkbox']"
		);
		return active ? active.getAttribute("data-value-id") : null;
	}
}

if (!customElements.get("product-variants")) {
	customElements.define("product-variants", ProductVariants);
}
